import { getCurrentScreenSizeInt } from 'PlugAndPlay/_global/js/screenSize';

export default function _requirementsPanel() {
    const jsTabs = document.querySelectorAll('.js-tab');
    const chooseProgramButton = document.querySelector('.active-program-tab');
    const programButtons = document.querySelectorAll('.program-course');
    const mainIcon = document.querySelector('.main-icon');
    const seeAllBtn = document.querySelector('.see-all-button');
    const minorReqAccBtn = document.querySelector(
        '.minor-requir-accordion-btn'
    );

    // function that hides dropdown menus
    function hideDropdownMenu(items) {
        items.forEach((item) => {
            if (item.classList.contains('show-dropdowm-menu')) {
                item.classList.remove('show-dropdowm-menu');
            } else if (item.classList.contains('default-tab')) {
                item.classList.remove('default-tab');
            }
        });
    }

    // function that handles click on dropdown links
    function ToggleTabs(container) {
        const tabs = container.querySelectorAll('.tab');
        const contents = container.querySelectorAll('.course-details');

        // Loop through each tab and add a click handler in order to switch between the tab contents
        tabs.forEach((tab) => {
            tab.addEventListener(
                'click',
                (el) => {
                    const tabTarget = tab.dataset.target;
                    const tabContent = container.querySelector(
                        `#t${tabTarget}`
                    );

                    // On mobile the tabs turn into a dropdown menu, so we add a 'show-dropdown-menu' class to activate the view when the currently active-tab is clicked
                    if (getCurrentScreenSizeInt() <= 3) {
                        if (tab.classList.contains('active-tab')) {
                            tabs.forEach((item) => {
                                item.classList.add('show-dropdowm-menu');
                            });
                        } else {
                            tabs.forEach((item) => {
                                item.classList.remove('show-dropdowm-menu');
                                item.classList.remove('active-tab');
                            });
                        }
                    } else {
                        tabs.forEach((item) => {
                            item.classList.remove('active-tab');
                        });
                    }

                    contents.forEach((item) => {
                        item.classList.add('hidden');
                    });

                    // After clearing all classes for the content and tabs, add active-tab to the currently clicked tab and remove the hidden class from that tabs target
                    tab.classList.add('active-tab');
                    tabContent.classList.remove('hidden');
                },
                false
            );
        });
    }

    // function that toggles programs dropdown
    function ToggleDropdownPrograms(head) {
        if (head) {
            head.addEventListener('click', () => {
                if (head.classList.contains('first-program-tab')) {
                    head.classList.remove('first-program-tab');
                    mainIcon.classList.remove('rotation');
                } else {
                    head.classList.add('first-program-tab');
                    mainIcon.classList.add('rotation');
                }

                programButtons.forEach((item) => {
                    item.classList.remove('hidden');
                    if (item.classList.contains('default-tab')) {
                        item.classList.remove('default-tab');
                    } else {
                        item.addEventListener('click', (e) => {
                            e.preventDefault();
                            const programTarget = item.dataset.programid;
                            const programContent = document.querySelector(
                                `.section-${programTarget}`
                            );

                            jsTabs.forEach((container) => {
                                container.classList.add('hidden');
                            });

                            programButtons.forEach((elm) => {
                                elm.classList.add('hidden');
                            });

                            programContent.classList.remove('hidden');

                            head.classList.remove('first-program-tab');
                            hideDropdownMenu(programButtons);
                        });
                        item.classList.add('default-tab');
                    }
                });
            });
        }
    }

    ToggleDropdownPrograms(chooseProgramButton);

    // function that handles the see all button
    if (seeAllBtn) {
        seeAllBtn.addEventListener('click', (e) => {
            e.preventDefault();
            jsTabs.forEach((container) => {
                container.classList.remove('hidden');
            });
        });
    }

    if (jsTabs.length > 0) {
        jsTabs.forEach((container) => {
            ToggleTabs(container);
        });
    }
}

_requirementsPanel();
